export const tournamentSystem = [
    'KO',
    'GroupKO',
    'RoundRobin',
];